import { Component, OnInit , Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.css']
})
export class DeletePopupComponent implements OnInit {
  public length = 0;
  public name: String = '';
  public action = 'Inactive';
  public typee = '';
  constructor(  @Inject(MAT_DIALOG_DATA) public data: any,
      public dialogRef: MatDialogRef<DeletePopupComponent>) { }

  ngOnInit() {
    if (this.data != null ) {
      this.name = this.data.name;
      this.length = this.data.length;
      if(this.data.action){
        this.action = this.data.action;
      }
      if(this.data.typee){
        this.typee = this.data.typee;
      }
    }
  }
  cancel() {
    this.dialogRef.close('Cancel');
  }
  proceed() {
    this.dialogRef.close('Proceed');
  }

}
